import React, { useState, useEffect } from 'react'
import { analytics } from '@helpers/analytics'
import { FilterOption } from '@helpers/filters/getFiltersOptionsState'
import Modal from '@components/ui/Modal'
import ModalProductCard, {
  ModalProductCardProps
} from '@components/ui/Modal/ModalProductCard'
import BackInStockFormWrapper from './BackInStockFormWrapper'
import { ProductOption } from '../../../types/product'
import styles from './styles.module.scss'
import { SelectedOptions, AvailableOptions } from './types'
import { useFit } from '@helpers/hooks/useFit'

function getDefaultOptions(
  options: {
    type: string
    values: string[]
    name: string
  }[],
  productFilterOptionsStoredInState: FilterOption[]
) {
  const availableOptions: AvailableOptions = []
  const defaultSelectedOptions: SelectedOptions = {}

  options.forEach(option => {
    const { type, name } = option
    const optionSizes = option.values.map(value => {
      return {
        value,
        label: value
      }
    })
    const matchToFilterOptionsStoredInState =
      productFilterOptionsStoredInState.find(
        stateOption => stateOption.type === option.type
      )
    const value = matchToFilterOptionsStoredInState
      ? matchToFilterOptionsStoredInState.value
      : ''

    defaultSelectedOptions[type] = value
    availableOptions.push({
      id: type,
      type,
      name,
      value,
      sizes: optionSizes
    })
  })

  return { availableOptions, defaultSelectedOptions }
}

type BackInStockModalProps = {
  onClose: () => void
  options: ProductOption[]
  title: string
  id: number
  image: {
    src: string
  }
  productFeed: {
    product_id?: string
  }
  productType: string
}

const updatedProductProperties = (
  selectedOptions: Record<string, string | number>
): Record<string, string | number> => {
  return Object.fromEntries(
    Object.entries(selectedOptions).map(([key, value]) => [
      key,
      value === '' ? '-' : value
    ])
  )
}

const BackInStockModal = ({
  onClose,
  options,
  title,
  productType,
  productFeed,
  id,
  image
}: BackInStockModalProps) => {
  const { filters } = useFit()

  const { availableOptions, defaultSelectedOptions } = getDefaultOptions(
    options,
    filters
  )
  const [selectedOptions, setSelectedOptions] = useState<SelectedOptions>(
    defaultSelectedOptions
  )

  useEffect(() => {
    analytics('Out of Stock - Displayed', {
      name: `${productType} - ${title}`
    })
  }, [])

  const selectedProduct = {
    productType,
    productFeed,
    id,
    options,
    title
  }

  const selectedProductProperties = {
    color: title,
    ...updatedProductProperties(selectedOptions)
  } as ModalProductCardProps['productProperties']

  return (
    <Modal
      content={
        <div className={styles.modalFormWrapper} role="presentation">
          <ModalProductCard
            image={image?.src}
            productType={productType}
            productProperties={selectedProductProperties}
          />
          <BackInStockFormWrapper
            selectedProduct={selectedProduct}
            selectedOptions={selectedOptions}
            availableOptions={availableOptions}
            setSelectedOptions={setSelectedOptions}
            handleCloseModal={onClose}
          />
        </div>
      }
      onClose={onClose}
      openedModal
    />
  )
}

export default BackInStockModal
